/**
 * Which UI a user has chosen: the original dashboard, or the /v1 console.
 *
 * Shared by both UIs on purpose — the old login reads it to decide where to land you, and
 * the v1 rail writes it when you switch back. Keeping it in one module means the key can't
 * drift between the two.
 *
 * Deliberately NOT used to redirect old /dashboard/* URLs. Opting in only changes where
 * login lands you; existing bookmarks keep rendering the old UI, so nobody gets trapped
 * somewhere unfamiliar mid-task.
 */

const KEY = "ui_preference";

export const UI_V1 = "v1";
export const UI_LEGACY = "legacy";

/** Returns "v1", "legacy", or null when they haven't been asked yet. */
export const getUiPreference = () => {
  try {
    const value = localStorage.getItem(KEY);
    return value === UI_V1 || value === UI_LEGACY ? value : null;
  } catch (_) {
    // Private mode / storage disabled: behave as "never asked" rather than breaking login.
    return null;
  }
};

export const setUiPreference = (value) => {
  try {
    localStorage.setItem(KEY, value);
  } catch (_) {
    /* nothing useful to do; the prompt will simply appear again next login */
  }
};

/** The user has been asked, whichever way they answered — don't prompt again. */
export const hasChosenUi = () => getUiPreference() !== null;

/**
 * Where a public "Sign in" link should point.
 *
 * v1 is the default front door, so anyone new signs in through the new console. The one
 * exception is a user who explicitly switched back to the old UI — sending them to the v1
 * login every time would be obtuse, and they'd end up in the old dashboard anyway.
 */
export const signInPath = () =>
  getUiPreference() === UI_LEGACY ? "/signin" : "/v1/signin";
